const colorCodeFormat = (color) => {
  if (color.includes('#')) {
      return color
  } else {
      return `#${color}`
  }
} 

export default colorCodeFormat